export const formatCurrency = (
  decimalValue: number,
  stripTrailingZeroes = true,
  locales: string[] = ["en-US"],
  currency = "USD",
): string => {
  const formatter = Intl.NumberFormat(locales, { style: "currency", currency });
  const formattedValue = formatter.format(decimalValue);

  // For Arabic locales, we need to check for ",00" at different positions
  if (stripTrailingZeroes) {
    // Handle Arabic and other RTL languages where the decimal part might be in a different position
    if (locales.some((locale) => locale.startsWith("ar"))) {
      if (formattedValue.includes(",00")) {
        return formattedValue.replace(",00", "");
      }
    } else {
      // Original logic for LTR languages
      const last3 = formattedValue.slice(-3);
      if (last3 === ".00" || last3 === ",00") {
        return formattedValue.slice(0, -3);
      }
    }
  }

  return formattedValue;
};
